import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './remove-habit-schedule-loading.style';

export const RemoveHabitScheduleLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
